export const pageTitleMap: Record<string, string> = {
  view: 'Tarkastele',
  pricing: 'Hinnat',
  customers: 'Asiakkaat',
  end: 'Lopputuoteasiakkaat',
  'carcass-collection': 'Raatokeräilyasiakkaat',
  partners: 'Kumppanit',
  slaughterhouses: 'Teurastamot',
  logistics: 'Logistiikka',
  products: 'Tuotteet',
  byproducts: 'Sivutuotteet',
  'end-products': 'Lopputuotteet',
  services: 'Palvelut'
};

export const pageTranslationKeyMap: Record<string, string> = {
  view: 'NAV.VIEW',
  pricing: 'NAV.PRICING',
  customers: 'NAV.CUSTOMERS',
  end: 'NAV.END_PRODUCT_CUSTOMERS',
  'carcass-collection': 'NAV.CARCASS_COLLECTION_CUSTOMERS',
  partners: 'NAV.PARTNERS',
  slaughterhouses: 'NAV.SLAUGHTERHOUSES',
  logistics: 'NAV.LOGISTICS',
  products: 'NAV.PRODUCTS',
  byproducts: 'NAV.BYPRODUCTS',
  'end-products': 'NAV.END_PRODUCTS',
  services: 'NAV.SERVICES'
};
